import React, { useState, useEffect, useRef } from 'react';
import {
  createRequest,
  getInstallationById,
  createServiceRemainder,
  getServiceRemainderRequestAPI,
  getSingleServiceRemainder,
  editServiceRemainder,
  deleteServiceRemainder,
  createBreakdown,
  getBreakdownRequestAPI,
  getSingleBreakdown,
  editBreakdown,
  deleteBreakdown,
  createSpare,
  getSpare,
  getSingleSpare,
  editSpare,
  deleteSpare,
  createResellScrap,
  getSingleResellScrap,
  createPurchaseOrder,
  transferMachineRequest,
} from '../../services/mm/apiController';
import { destroy } from '../../services/apiController';
import { Link, useParams, useNavigate, useLocation } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { Table, Row, Modal, Button, Form, FloatingLabel, Tabs, Tab, Col, Alert } from 'react-bootstrap';
import { formatDate } from '../../util/helper';
import { DeleteIcon, DownloadIcon, EditIcon, ViewIcon } from '../vm/components/icons';
import { TABLE_DEFAULT_LIMIT, DEBOUNCE_DELAY } from '../../util/constant';
import { get_auth_key, getStoredData } from '../../util';
import { MdDelete } from 'react-icons/md';
import moment from 'moment';
import AlertIcon from '../../img.svg';
import { useSelector } from 'react-redux';
import useDebounce from '../useDebounce';
import { factoryId } from '../../store/reducers/account_reducer';
import PaginationInPage from '../Pagination';
import axios from 'axios';
import BreakdownDetail from './breakdownDetail';
import DieselLogEntry from './components/diesel-log-entries';

const InstallationDetails = () => {
  let params = useParams();
  const factoryId_ = useSelector(factoryId);
  const navigate = useNavigate();
  const storedData = JSON.parse(getStoredData(get_auth_key()));
  const [status, setStatus] = useState('');
  const [installationDetail, setInstallationDetail] = useState('');
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [showServiceRemainderModal, setShowServiceRemainderModal] = useState(false);
  const [showBreakdownModal, setShowBreakdownModal] = useState(false);
  const [showSpareModal, setShowSpareModal] = useState(false);
  const [showResellScrapModal, setShowResellScrapModal] = useState(false);
  const [showTransferModal, setShowTransferModal] = useState(false);
  const [validated, setValidated] = useState(false);
  const [fieldToDeleted, setFieldToDeleted] = useState('');
  const [inputFields, setInputFields] = useState([]);
  const [subTotal, setSubTotal] = useState(0);
  const [viewDetail, setViewDetail] = useState(false);
  const [documentShowConfirmModel, setDocumentShowConfirmModel] = useState(false);
  const [documentShowResellConfirmModel, setDocumentShowResellConfirmModel] = useState(false);
  const clickSpareBtn = useRef(null);
  const formFields = {
    name: '',
    description: '',
    dueDate: '',
    type: 'FREE',
    status: 'PENDING',
    installationId: params.id,
    serviceCost: null,
    materialCost: '',
    technicianName: '',
    technicianContactNumber: '',
    serviceComments: '',
    isAmc: false,
    servicedDate: '',
    supervisedBy: '',
    document1: null,
    file_1: '',
    document2: null,
    file_2: '',
    document3: null,
    file_3: '',
    document4: null,
    file_4: '',
    factoryId: factoryId_,
    createdBy: '02a08619-56a5-4c94-9728-94f4e4d2a1c8',
  };
  const breakdownFormFields = {
    model: installationDetail?.item,
    section: installationDetail?.section,
    breakDate: '',
    status: '',
    reason: '',
    document1: null,
    file_1: '',
    document2: null,
    file_2: '',
    document3: null,
    file_3: '',
    document4: null,
    file_4: '',
    document5: null,
    file_5: '',
    document6: null,
    file_6: '',
    document7: null,
    file_7: '',
    document8: null,
    file_8: '',
    document9: null,
    file_9: '',
    document10: null,
    file_10: '',
    technicianName: '',
    technicianContactNumber: '',
    servicedDate: '',
    serviceComments: '',
    serviceCost: null,
    materialCost: null,
    supervisedBy: '',
    isAmc: false,
    installationId: params.id,
    factoryId: factoryId_,
    createdBy: '02a08619-56a5-4c94-9728-94f4e4d2a1c8',
  };
  const spareFormFields = {
    name: '',
    quantity: '',
    description: '',
    document1: null,
    file1: '',
    document2: null,
    file2: '',
    installationId: params.id,
    factoryId: factoryId_,
    createdBy: '02a08619-56a5-4c94-9728-94f4e4d2a1c8',
  };
  const resellScrapFormFields = {
    type: '',
    date: '',
    to_whom: '',
    buyerContactNumber: '',
    buyerEmail: '',
    buyerContactPerson: '',
    buyerGST: '',
    resellAmount: '',
    reason: '',
    approvedBy: '',
    supervisedBy: '',
    document1: null,
    file_1: '',
    document2: null,
    file_2: '',
    document3: null,
    file_3: '',
    installationId: params.id,
    factoryId: factoryId_,
    createdBy: '02a08619-56a5-4c94-9728-94f4e4d2a1c8',
  };
  const poFormFields = {
    poNumber: '',
    item: installationDetail?.item,
    section: installationDetail?.section,
    amount: '',
    approvedDate: '',
    initiatedBy: '',
    file1: null,
    file_1: '',
    file2: null,
    file_2: '',
    file3: null,
    file_3: '',
    installationID: params.id,
    requestId: installationDetail?.requestId,
    factoryId: factoryId_,
    createdBy: '02a08619-56a5-4c94-9728-94f4e4d2a1c8',
  };
  const transferValueFormFields = {
    installationId: params.id,
    factoryId: '',
    approvedBy: '',
    reason: '',
    supervisedBy: '',
    userId: storedData.displayName,
  };
  const [purchaseOrderForm, setPurchaseOrderForm] = useState(poFormFields);
  const [serviceForm, setServiceForm] = useState(formFields);
  const [breakdownForm, setBreakdownForm] = useState(breakdownFormFields);
  const [spareForm, setSpareForm] = useState(spareFormFields);
  const [resellScrapForm, setResellScrapForm] = useState(resellScrapFormFields);
  const [transferValue, setTransferValue] = useState(transferValueFormFields);
  const [serviceList, setServiceList] = useState([]);
  const [breakdownList, setBreakdownList] = useState([]);
  const [spareList, setSpareList] = useState([]);
  const [serviceName, setServiceName] = useState('');
  const [spareName, setSpareName] = useState('');
  const [resellScrapInfo, setResellScrapInfo] = useState('');
  const [showConfirmModel, setShowConfirmModel] = useState(false);
  const branches = useSelector((state) => state.common.vmBranches);
  const factories = branches.filter((item) => item?.type === 'factory');
  const [breakdownShowConfirmModel, setBreakdownShowConfirmModel] = useState(false);
  const [spareShowConfirmModel, setSpareShowConfirmModel] = useState(false);

  const handleAddInput = async () => {
    const newSpareInfo = [...inputFields];
    newSpareInfo.push({
      spareName: '',
      numbers: '',
      price: '',
      labourCost: '',
      totalAmount: '',
    });
    setInputFields(newSpareInfo);
    setBreakdownForm({ ...breakdownForm, sparesInfo: newSpareInfo });
  };

  const handleRemoveInput = (index) => {
    const newSpareInfo = [...inputFields];
    setSubTotal(parseInt(subTotal) - parseInt(newSpareInfo[index]['totalAmount'] || 0));
    newSpareInfo.splice(index, 1);
    setInputFields(newSpareInfo);
    setBreakdownForm({ ...breakdownForm, sparesInfo: newSpareInfo });
  };

  const handleInputChange = (index, event, fieldName) => {
    let newSpareInfo = [...inputFields];
    const value = event.target.value;

    newSpareInfo[index][fieldName] = value;

    if (fieldName === 'price' || fieldName === 'numbers' || fieldName === 'labourCost') {
      const quantity = parseFloat(newSpareInfo[index]['numbers'] || 0);
      const rate = parseFloat(newSpareInfo[index]['price'] || 0);
      const labourCost = parseFloat(newSpareInfo[index]['labourCost'] || 0);

      // Update totalAmount for the current index
      newSpareInfo[index]['totalAmount'] = quantity * rate + labourCost;
    }

    let finalamount = 0;
    for (let i = 0; i < newSpareInfo.length; i++) {
      finalamount += parseFloat(newSpareInfo[i]?.totalAmount || 0);
    }
    setSubTotal(finalamount);
    setInputFields(newSpareInfo);
    setBreakdownForm({ ...breakdownForm, sparesInfo: newSpareInfo });
  };

  const handleCloseDocumentConfirmModal = () => {
    setDocumentShowConfirmModel(false);
  };

  const handleCloseDocumentResellConfirmModal = () => {
    setDocumentShowResellConfirmModel(false);
  };
  const handleCloseConfirmModal = () => {
    setShowConfirmModel(false);
  };
  const handleCloseBreakdownConfirmModal = () => {
    setBreakdownShowConfirmModel(false);
  };
  const handleCloseSpareConfirmModal = () => {
    setSpareShowConfirmModel(false);
  };
  const [idToDeleted, setIdToDeleted] = useState('');
  const handleCloseServiceRemainderModal = () => {
    setShowServiceRemainderModal(false);
  };
  const handleCloseBreakdownModal = () => {
    setShowBreakdownModal(false);
    setInputFields([]);
    setSubTotal(0);
  };
  const handleCloseSpareModal = () => {
    setShowSpareModal(false);
  };
  const handleCloseResellScrapModal = () => {
    setShowResellScrapModal(false);
  };
  const machineRequestFormFields = {
    model: installationDetail.item,
    section: installationDetail.section,
    requestedBy: '',
    initiatedBy: '',
    requestedDate: '',
    reason: '',
    file1: null,
    file1Name: '',
    file2: null,
    file2Name: '',
    installationId: params.id,
    factoryId: factoryId_,
    createdBy: '02a08619-56a5-4c94-9728-94f4e4d2a1c8',
  };
  const [machineForm, setMachineForm] = useState(machineRequestFormFields);
  const clickToDownload = useRef(null);
  const [show, setShow] = useState(false);
  const [showPurchaseModal, setShowPurchaseModal] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const handleCloseModal = () => {
    setShowPurchaseModal(false);
  };

  const handleShowModal = () => {
    setPurchaseOrderForm({
      ...purchaseOrderForm,
      installationId: params.id,
      item: installationDetail?.item,
      section: installationDetail?.section,
      requestId: installationDetail?.requestId,
    });
    setShowPurchaseModal(true);
    setValidated(false);
  };

  const handleShowTransferModal = () => {
    setShowTransferModal(true);
    setValidated(false);
  };

  const handleClose = () => {
    setShow(false);
    setInputFields([]);
    setSubTotal(0);
    setViewDetail(false);
  };

  const handleShow = () => {
    setShow(true);
    setMachineForm(machineRequestFormFields);
  };

  const handleShowServiceRemainderModal = () => {
    setShowServiceRemainderModal(true);
    setValidated(false);
    setServiceForm(formFields);
  };

  const handleShowBreakdownModal = () => {
    setShowBreakdownModal(true);
    setValidated(false);
    setBreakdownForm(breakdownFormFields);
    setTimeout(() => {
      clickSpareBtn.current?.click();
    }, 100);
  };

  const handleCloseTransferModal = () => {
    setShowTransferModal(false);
  };

  const deleteFile = (field) => {
    try {
      destroy(`/mm/installation/filefrom/${params.id}/${field}`)
        .then((resp) => {
          setInstallationDetail(resp.data);
          setDocumentShowConfirmModel(false);
        })
        .catch((error) => {
          toast.error(error.message);
        });
    } catch (e) {
      toast.error(e.message);
    }
  };

  const deleteResellFile = (field) => {
    try {
      destroy(`/mm/resell-scrap/filefrom/${resellScrapInfo.id}/${field}`)
        .then((resp) => {
          setResellScrapInfo(resp.data);
          setDocumentShowResellConfirmModel(false);
        })
        .catch((error) => {
          toast.error(error.message);
        });
    } catch (e) {
      toast.error(e.message);
    }
  };

  const handleShowSpareModal = () => {
    setShowSpareModal(true);
    setValidated(false);
    setSpareForm(spareFormFields);
  };

  const handleShowResellScrapModal = () => {
    setShowResellScrapModal(true);
    setValidated(false);
    setResellScrapForm(resellScrapFormFields);
  };

  const handleMachineChange = (event) => {
    event.preventDefault();
    let name = event.target.name;
    let value = event.target.value;
    setMachineForm({ ...machineForm, [name]: value });
  };

  const onChangeDocumentOne = (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file && file.name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      e.target.value = ''; // Clear the selected file
      toast.error('Please select a valid file type.', { autoClose: 2000 });
    } else {
      const file = e.target.files[0] || null;
      const { name } = e.target;

      const formData = new FormData();
      formData.append('fileName', file);

      axios
        .post(process.env.REACT_APP_BASE_URL + '/mm/file', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'x-access-token': storedData.token,
          },
        })
        .then((resp) => {
          if (resp.status === 200) {
            // Handle success
            setMachineForm({ ...machineForm, [name]: resp.data });
          } else {
            // Handle other status codes if needed
            toast.error('Error');
          }
        })
        .catch((err) => {
          // Handle error
          console.log(err);
          toast.error('Error');
        });
    }
  };

  const handleChange = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    setServiceForm({ ...serviceForm, [name]: value });
  };

  const handleBreakdownChange = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    setBreakdownForm({ ...breakdownForm, [name]: value });
  };

  const handleSpareChange = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    setSpareForm({ ...spareForm, [name]: value });
  };

  const handleChangeScrap = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    setResellScrapForm({ ...resellScrapForm, [name]: value });
  };

  const handleSelect = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    setServiceForm({ ...serviceForm, [name]: value });
  };

  const handleBreakdownSelect = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    setBreakdownForm({ ...breakdownForm, [name]: value });
  };

  const handleResellScrapSelect = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    setResellScrapForm({ ...resellScrapForm, [name]: value });
  };

  const handleSectionSelect = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    setMachineForm({ ...machineForm, [name]: value });
  };

  const handlePOSectionSelect = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    setPurchaseOrderForm({ ...purchaseOrderForm, [name]: value });
  };

  const onChangeDocument1 = (e) => {
    e.preventDefault();
    if (e.target.files[0] && e.target.files[0].name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      setServiceForm({ ...serviceForm, file1: null, file_1: '' });
      toast.error('Please select a valid file type.');
    } else {
      const file = e.target.files[0] || null;

      const formData = new FormData();
      formData.append('fileName', file);

      axios
        .post(process.env.REACT_APP_BASE_URL + '/mm/file', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'x-access-token': storedData.token,
          },
        })
        .then((resp) => {
          if (resp.status === 200) {
            // Handle success
            setServiceForm({ ...serviceForm, file_1: resp.data });
          } else {
            // Handle other status codes if needed
            toast.error('Error');
          }
        })
        .catch((err) => {
          // Handle error
          console.log(err);
          toast.error('Error');
        });
    }
  };

  const onChangeDocument2 = (e) => {
    e.preventDefault();
    if (e.target.files[0] && e.target.files[0].name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      setServiceForm({ ...serviceForm, file2: null, file_2: '' });
      toast.error('Please select a valid file type.');
    } else {
      const file = e.target.files[0] || null;

      const formData = new FormData();
      formData.append('fileName', file);

      axios
        .post(process.env.REACT_APP_BASE_URL + '/mm/file', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'x-access-token': storedData.token,
          },
        })
        .then((resp) => {
          if (resp.status === 200) {
            // Handle success
            setServiceForm({ ...serviceForm, file_2: resp.data });
          } else {
            // Handle other status codes if needed
            toast.error('Error');
          }
        })
        .catch((err) => {
          console.log(err);
          toast.error('Error');
        });
    }
  };

  const onChangeDocument3 = (e) => {
    e.preventDefault();
    if (e.target.files[0] && e.target.files[0].name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      setServiceForm({ ...serviceForm, file3: null, file_3: '' });
      toast.error('Please select a valid file type.');
    } else {
      const file = e.target.files[0] || null;

      const formData = new FormData();
      formData.append('fileName', file);

      axios
        .post(process.env.REACT_APP_BASE_URL + '/mm/file', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'x-access-token': storedData.token,
          },
        })
        .then((resp) => {
          if (resp.status === 200) {
            // Handle success
            setServiceForm({ ...serviceForm, file_3: resp.data });
          } else {
            // Handle other status codes if needed
            toast.error('Error');
          }
        })
        .catch((err) => {
          // Handle error
          console.log(err);
          toast.error('Error');
        });
    }
  };

  const onChangeDocument4 = (e) => {
    e.preventDefault();
    if (e.target.files[0] && e.target.files[0].name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      setServiceForm({ ...serviceForm, file4: null, file_4: '' });
      toast.error('Please select a valid file type.');
    } else {
      const file = e.target.files[0] || null;

      const formData = new FormData();
      formData.append('fileName', file);

      axios
        .post(process.env.REACT_APP_BASE_URL + '/mm/file', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'x-access-token': storedData.token,
          },
        })
        .then((resp) => {
          if (resp.status === 200) {
            // Handle success
            setServiceForm({ ...serviceForm, file_4: resp.data });
          } else {
            // Handle other status codes if needed
            toast.error('Error');
          }
        })
        .catch((err) => {
          // Handle error
          console.log(err);
          toast.error('Error');
        });
    }
  };

  const onChangeBreakDocument = (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file && file.name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      e.target.value = ''; // Clear the selected file
      toast.error('Please select a valid file type.', { autoClose: 2000 });
    } else {
      const file = e.target.files[0] || null;

      const { name } = e.target;

      const formData = new FormData();
      formData.append('fileName', file);

      axios
        .post(process.env.REACT_APP_BASE_URL + '/mm/file', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'x-access-token': storedData.token,
          },
        })
        .then((resp) => {
          if (resp.status === 200) {
            // Handle success
            setBreakdownForm({ ...breakdownForm, [name]: resp.data });
          } else {
            // Handle other status codes if needed
            toast.error('Error');
          }
        })
        .catch((err) => {
          // Handle error
          toast.error('Error');
        });
    }
  };

  const onChangeSpareDocument = (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file && file.name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      e.target.value = ''; // Clear the selected file
      toast.error('Please select a valid file type.', { autoClose: 2000 });
    } else {
      const file = e.target.files[0] || null;
      const { name } = e.target;

      const formData = new FormData();
      formData.append('fileName', file);

      axios
        .post(process.env.REACT_APP_BASE_URL + '/mm/file', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'x-access-token': storedData.token,
          },
        })
        .then((resp) => {
          if (resp.status === 200) {
            // Handle success
            setSpareForm({ ...spareForm, [name]: resp.data });
          } else {
            // Handle other status codes if needed
            toast.error('Error');
          }
        })
        .catch((err) => {
          // Handle error
          console.log(err);
          toast.error('Error');
        });
    }
  };

  const onChangeResellScrapDocument = (e) => {
    e.preventDefault('onChangeResellScrapDocument');
    const file = e.target.files[0];
    if (file && file.name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      e.target.value = ''; // Clear the selected file
      toast.error('Please select a valid file type.', { autoClose: 2000 });
    } else {
      const file = e.target.files[0] || null;

      const { name } = e.target;

      const formData = new FormData();
      formData.append('fileName', file);

      axios
        .post(process.env.REACT_APP_BASE_URL + '/mm/file', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'x-access-token': storedData.token,
          },
        })
        .then((resp) => {
          if (resp.status === 200) {
            // Handle success
            setResellScrapForm({ ...resellScrapForm, [name]: resp.data });
          } else {
            // Handle other status codes if needed
            toast.error('Error');
          }
        })
        .catch((err) => {
          // Handle error
          console.log(err);
          toast.error('Error');
        });
    }
  };

  useEffect(() => {
    getInstallation();
  }, []);

  const getInstallation = async () => {
    const installationVal = await getInstallationById(params?.id);
    setInstallationDetail(installationVal?.data);
  };

  const handleShowDocumentModal = (e, field) => {
    e.preventDefault();
    setDocumentShowConfirmModel(true);
    setFieldToDeleted(field);
  };

  const handleShowResellDocumentModal = (e, field) => {
    e.preventDefault();
    setDocumentShowResellConfirmModel(true);
    setFieldToDeleted(field);
  };

  /** Add/Edit Service */
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!serviceForm.name || !serviceForm.description || !serviceForm.dueDate) {
      toast.error('Please fill in all the required fields.');
      return;
    }
    const newForm = {
      name: serviceForm.name,
      description: serviceForm.description,
      dueDate: serviceForm.dueDate,
      type: serviceForm.type,
      status: serviceForm.status,
      installationId: params.id,
      factoryId: factoryId_,
      createdBy: '02a08619-56a5-4c94-9728-94f4e4d2a1c8',
    };
    await setServiceForm({ ...serviceForm, installationId: installationDetail?.id });
    if (serviceForm.id) {
      try {
        setIsButtonDisabled(false);
        if (
          serviceForm.status === 'COMPLETED' &&
          (!serviceForm.technicianName ||
            !serviceForm.technicianContactNumber ||
            !serviceForm.servicedDate ||
            !serviceForm.supervisedBy ||
            (serviceForm.isAmc === false && !serviceForm.serviceCost))
        ) {
          toast.error('Please fill in all the required fields.');
          return;
        }
        await editServiceRemainder(serviceForm.id, serviceForm);
        toast.success('Service Remainder updated successfully');
        setShowServiceRemainderModal(false);
        getService();
      } catch (err) {
        toast.error(err?.response?.data?.data?.message || 'Something went wrong', { autoClose: 3000 });
      }
    } else {
      if (isButtonDisabled) {
        return; // If button is disabled, return early
      }
      setIsButtonDisabled(true); // Disable the button
      try {
        if (serviceForm.status == 'PENDING') {
          const resp = await createServiceRemainder(newForm);
        } else {
          if (
            !serviceForm.technicianName ||
            !serviceForm.technicianContactNumber ||
            !serviceForm.servicedDate ||
            !serviceForm.supervisedBy ||
            (serviceForm.isAmc === false && !serviceForm.serviceCost)
          ) {
            toast.error('Please fill in all the required fields.');
            return;
          }
          const resppp = await createServiceRemainder(serviceForm);
        }
        toast.success('Service Remainder Created successfully');
        setShowServiceRemainderModal(false);
        getService();
      } catch (err) {
        console.log(err);
        toast.error(err?.message || 'Something went wrong', { autoClose: 3000 });
      } finally {
        // Enable the button after a delay of 3 seconds
        setTimeout(() => {
          setIsButtonDisabled(false);
        }, 500);
      }
    }
  };

  const handleMachineSubmit = async (event) => {
    event.preventDefault();
    try {
      if (
        !machineForm.model ||
        !machineForm.section ||
        !machineForm.requestedBy ||
        !machineForm.initiatedBy ||
        !machineForm.requestedDate ||
        !machineForm.reason
      ) {
        toast.error('Please fill in all the required fields.');
        return;
      }
      await createRequest(machineForm);
      toast.success('Machine Request added successfully');
      setShow(false);
      getInstallation();
    } catch (err) {
      toast.error(err.message, { autoClose: 2000 });
    }
  };

  const handleSubmitBreakdown = async (e) => {
    e.preventDefault();
    if (!breakdownForm.breakDate || !breakdownForm.status || !breakdownForm.reason) {
      toast.error('Please fill in all the required fields.');
      return;
    }
    const nBreakForm = {
      model: installationDetail?.item,
      section: breakdownForm.section,
      breakDate: breakdownForm.breakDate,
      reason: breakdownForm.reason,
      status: breakdownForm.status,
      installationId: params.id,
      factoryId: factoryId_,
      createdBy: '02a08619-56a5-4c94-9728-94f4e4d2a1c8',
    };
    setBreakdownForm({
      ...breakdownForm,
      model: installationDetail?.item,
      section: installationDetail?.section,
      installationId: installationDetail?.id,
    });
    if (breakdownForm.id) {
      try {
        setIsButtonDisabled(false);
        if (
          breakdownForm.status === 'REPAIRED' &&
          (!breakdownForm.technicianName ||
            !breakdownForm.technicianContactNumber ||
            !breakdownForm.servicedDate ||
            !breakdownForm.supervisedBy ||
            (breakdownForm.isAmc === false && !breakdownForm.serviceCost))
        ) {
          toast.error('Please fill in all the required fields.');
          return;
        }
        const breakdownValue = await editBreakdown(breakdownForm.id, { ...breakdownForm, subTotal: subTotal });
        toast.success('Breakdown updated successfully');
        setShowBreakdownModal(false);
        setInputFields([]);
        setSubTotal(0);
        getBreak();
      } catch (err) {
        toast.error(err.message);
      }
    } else {
      if (isButtonDisabled) {
        return; // If button is disabled, return early
      }
      setIsButtonDisabled(true); // Disable the button
      try {
        if (breakdownForm.status == 'PENDING') {
          const breakdownResp = await createBreakdown({ ...nBreakForm, subTotal: subTotal });
          toast.success('Breakdown Created successfully');
          setShowBreakdownModal(false);
          setInputFields([]);
          setSubTotal(0);
          getBreak();
        } else {
          if (
            !breakdownForm.technicianName ||
            !breakdownForm.technicianContactNumber ||
            !breakdownForm.servicedDate ||
            !breakdownForm.supervisedBy ||
            (breakdownForm.isAmc === false && !breakdownForm.serviceCost)
          ) {
            toast.error('Please fill in all the required fields.');
            return;
          }
          const breakdownResssp = await createBreakdown({ ...breakdownForm, subTotal: subTotal });
          toast.success('Breakdown Created successfully');
          setShowBreakdownModal(false);
          setInputFields([]);
          setSubTotal(0);
          getBreak();
        }
      } catch (err) {
        toast.error(err?.message || 'Something went wrong', { autoClose: 3000 });
      } finally {
        // Enable the button after a delay of 3 seconds
        setTimeout(() => {
          setIsButtonDisabled(false);
        }, 500);
      }
    }
  };

  const handleSubmitSpare = async (e) => {
    e.preventDefault();
    if (!spareForm.name || !spareForm.quantity) {
      toast.error('Please fill in all the required fields.');
      return;
    }
    if (spareForm.id) {
      try {
        setIsButtonDisabled(false);
        const spareValue = await editSpare(spareForm, spareForm.id);
        toast.success('Spare updated successfully');
        setShowSpareModal(false);
        getSpares();
      } catch (err) {
        console.error(err);
        toast.error(err.message);
      }
    } else {
      if (isButtonDisabled) {
        return; // If button is disabled, return early
      }
      setIsButtonDisabled(true); // Disable the button
      try {
        await createSpare(spareForm);
        toast.success('Spare Created successfully');
        setShowSpareModal(false);
        getSpares();
      } catch (err) {
        console.error(err);
        toast.error(err.message);
      } finally {
        // Enable the button after a delay of 3 seconds
        setTimeout(() => {
          setIsButtonDisabled(false);
        }, 500);
      }
    }
  };

  const handleTransferChange = (event) => {
    event.preventDefault();
    let name = event.target.name;
    let value = event.target.value;
    setTransferValue({ ...transferValue, [name]: value });
  };

  const handleFactory = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    setTransferValue({ ...transferValue, [name]: value });
  };

  /** Resell Scrap */
  const handleSubmitResellScrap = async (e) => {
    e.preventDefault();
    try {
      if (
        !resellScrapForm.type ||
        !resellScrapForm.date ||
        !resellScrapForm.to_whom ||
        !resellScrapForm.buyerContactNumber ||
        !resellScrapForm.buyerEmail ||
        !resellScrapForm.resellAmount ||
        !resellScrapForm.reason ||
        !resellScrapForm.approvedBy
      ) {
        toast.error('Please fill in all the required fields.');
        return;
      }
      await createResellScrap(resellScrapForm);
      toast.success('Resell Scrap Created successfully');
      setShowResellScrapModal(false);
      getResellScraping();
    } catch (err) {
      toast.error(err?.response?.data?.data?.message || 'Something went wrong', { autoClose: 3000 });
    }
  };

  const getServiceRemainderList = async (limit = TABLE_DEFAULT_LIMIT, offset = 0) => {
    try {
      let condition = {
        name: serviceName || '',
      };
      const serviceRemainderList = await getServiceRemainderRequestAPI(offset - 1, limit, params.id, condition);

      return {
        data: (serviceRemainderList && serviceRemainderList.data.rows) || [],
        totalRecords: (serviceRemainderList && serviceRemainderList.data && serviceRemainderList.data.count) || 0,
      };
    } catch (e) {
      console.error(e);
      return {
        errorMessage: e.message,
      };
    }
  };

  const getBreakdownList = async (limit = TABLE_DEFAULT_LIMIT, offset = 0) => {
    try {
      let condition = {
        status: status || '',
      };
      const breakdownList = await getBreakdownRequestAPI(offset - 1, limit, params.id, condition);

      return {
        data: (breakdownList && breakdownList.data.rows) || [],
        totalRecords: (breakdownList && breakdownList.data && breakdownList.data.count) || 0,
      };
    } catch (e) {
      console.error(e);
      return {
        errorMessage: e.message,
      };
    }
  };

  const getSpareList = async (limit = TABLE_DEFAULT_LIMIT, offset = 0) => {
    try {
      let condition = {
        name: spareName || '',
      };
      const spareList = await getSpare(offset - 1, limit, params.id, condition);
      return {
        data: (spareList && spareList.data.rows) || [],
        totalRecords: (spareList && spareList.data && spareList.data.count) || 0,
      };
    } catch (e) {
      console.error(e);
      return {
        errorMessage: e.message,
      };
    }
  };

  useEffect(() => {
    getService();
    getBreak();
    getSpares();
    getResellScraping();
  }, []);

  useDebounce(
    () => {
      getService();
    },
    [serviceName],
    DEBOUNCE_DELAY
  );

  useDebounce(
    () => {
      getBreak();
    },
    [status],
    DEBOUNCE_DELAY
  );

  useDebounce(
    () => {
      getSpares();
    },
    [spareName],
    DEBOUNCE_DELAY
  );

  const getService = async () => {
    const listServiceRemainder = await getServiceRemainderList(TABLE_DEFAULT_LIMIT, currentPage);
    setTotalRecords(listServiceRemainder.totalRecords);
    setServiceList(listServiceRemainder.data);
  };

  const getBreak = async () => {
    const listBreakdown = await getBreakdownList(TABLE_DEFAULT_LIMIT, currentPage);
    setTotalRecords(listBreakdown.totalRecords);
    setBreakdownList(listBreakdown.data);
  };

  const getSpares = async () => {
    const listSpare = await getSpareList(TABLE_DEFAULT_LIMIT, currentPage);
    setTotalRecords(listSpare.totalRecords);
    setSpareList(listSpare.data);
  };

  const editServiceRemainderRequest = async (e, id) => {
    e.preventDefault();
    const getServiceRemainder = async () => {
      const data = await getSingleServiceRemainder(id);
      const hole = data?.data;
      hole.dueDate = moment(hole.dueDate).format('YYYY-MM-DD');
      hole.isAmc == 1 ? (hole.isAmc = true) : (hole.isAmc = false);
      if (hole.servicedDate !== null) hole.servicedDate = moment(hole.servicedDate).format('YYYY-MM-DD');
      hole.document1 = null;
      hole.document2 = null;
      hole.document3 = null;
      hole.document4 = null;
      setServiceForm(hole);
      setShowServiceRemainderModal(true);
    };
    getServiceRemainder();
  };

  const editAndViewBreakdownRequest = async (e, id, type) => {
    e.preventDefault();
    const getBreaksDown = async () => {
      const data = await getSingleBreakdown(id);
      data.data.breakDate = moment(data.data.breakDate).format('YYYY-MM-DD');
      if (data.data.servicedDate !== null) data.data.servicedDate = moment(data.data.servicedDate).format('YYYY-MM-DD');
      const breakDownData = data.data;
      breakDownData.isAmc == 1 ? (breakDownData.isAmc = true) : (breakDownData.isAmc = false);
      for (let index = 1; index < 11; index++) {
        breakDownData['document' + index] = null;
      }
      const _inputFields = breakDownData.sparesInfo;
      setBreakdownForm(breakDownData);
      setInputFields(_inputFields);
      setSubTotal(data.data.subTotal || 0);
      if (type === 'edit') {
        setShowBreakdownModal(true);
      }
      if (type === 'view') {
        setViewDetail(true);
      }
    };
    getBreaksDown();
  };

  const editSpareRequest = async (e, id) => {
    e.preventDefault();
    const getSpareValue = async () => {
      const data = await getSingleSpare(id);
      const spareData = data.data;
      for (let index = 1; index < 11; index++) {
        spareData['document' + index] = null;
      }
      setSpareForm(spareData);
      setShowSpareModal(true);
    };
    getSpareValue();
  };

  const getResellScraping = async () => {
    const data = await getSingleResellScrap(params.id);
    setResellScrapInfo(data.data);
  };

  const handleShowConfirmModal = (e, id) => {
    e.preventDefault();
    setShowConfirmModel(true);
    setIdToDeleted(id);
  };

  const handleBreakdownConfirmModal = (e, id) => {
    e.preventDefault();
    setBreakdownShowConfirmModel(true);
    setIdToDeleted(id);
  };

  const handleSpareConfirmModal = (e, id) => {
    e.preventDefault();
    setSpareShowConfirmModel(true);
    setIdToDeleted(id);
  };

  const handleRemove = (event, id) => {
    event.preventDefault();
    const deleteService = async () => {
      const data = await deleteServiceRemainder(id);
      toast.success(data.data);
      getService();
      setShowConfirmModel(false);
    };
    deleteService();
  };

  const handleRemoveBreakdown = (event, id) => {
    event.preventDefault();
    const deleteBreak = async () => {
      const data = await deleteBreakdown(id);
      toast.success(data.data);
      getBreak();
      setBreakdownShowConfirmModel(false);
    };
    deleteBreak();
  };

  const handleRemoveSpare = (event, id) => {
    event.preventDefault();
    const deleteSpares = async () => {
      const data = await deleteSpare(id);
      toast.success(data.data);
      getSpares();
      setSpareShowConfirmModel(false);
    };
    deleteSpares();
  };

  const handleToggle = (e) => {
    const { checked } = e.target;
    setServiceForm({ ...serviceForm, isAmc: checked });
  };

  const handleToggleBreak = (e) => {
    const { checked } = e.target;
    setBreakdownForm({ ...breakdownForm, isAmc: checked });
  };

  const handleChangePurchaseOrder = (e) => {
    e.preventDefault();
    let name = e.target.name;
    let value = e.target.value;
    setPurchaseOrderForm({ ...purchaseOrderForm, [name]: value });
  };

  const onChangePurchaseDocumentOne = (e) => {
    e.preventDefault();
    const file = e.target.files[0];
    if (file && file.name.match(/\.(exe|apk|bat|cmd|com|dll|jar|msi|py|sh)$/)) {
      e.target.value = ''; // Clear the selected file
      toast.error('Please select a valid file type.', { autoClose: 2000 });
    } else {
      const file = e.target.files[0] || null;

      const { name } = e.target;

      const formData = new FormData();
      formData.append('fileName', file);

      axios
        .post(process.env.REACT_APP_BASE_URL + '/mm/file', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'x-access-token': storedData.token,
          },
        })
        .then((resp) => {
          if (resp.status === 200) {
            // Handle success
            setPurchaseOrderForm({ ...purchaseOrderForm, [name]: resp.data });
          } else {
            // Handle other status codes if needed
            toast.error('Error');
          }
        })
        .catch((err) => {
          // Handle error
          console.log(err);
          toast.error('Error');
        });
    }
  };

  const handleTransferSubmit = async (e) => {
    e.preventDefault();
    try {
      await transferMachineRequest(transferValue);
      setShowTransferModal(false);
      navigate('/mm/installation');
      setTimeout(() => {
        toast.success('Machine Transfered successfully');
      }, 1000);
    } catch (err) {
      console.error(err);
      toast.error(err.message);
    }
  };

  const handleApprove = async (e) => {
    e.preventDefault();
    try {
      if (
        !purchaseOrderForm.item ||
        !purchaseOrderForm.poNumber ||
        !purchaseOrderForm.section ||
        !purchaseOrderForm.amount ||
        !purchaseOrderForm.approvedDate ||
        !purchaseOrderForm.file_1
      ) {
        toast.error('Please fill in all the required fields.');
        return;
      }
      await createPurchaseOrder(purchaseOrderForm);
      setShowPurchaseModal(false);
      getInstallation();
    } catch (err) {
      console.error(err);
      toast.error(err.message);
    }
  };

  const [activeTabKey, setActiveTabKey] = useState(null);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  useEffect(() => {
    const tabFromQueryParam = searchParams.get('activeTab');
    setActiveTabKey(tabFromQueryParam || 'request');
  }, []);

  return (
    <React.Fragment>
      <ToastContainer />
      <nav className="" aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <Link to="/mm/installation">Installation List</Link>
          </li>
          <li className="breadcrumb-item">
            <Link to="">Installation Detail</Link>
          </li>
        </ol>
      </nav>
      <div className="card">
        <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
          <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
            Installation Detail
          </h4>
          <a ref={clickToDownload} href="/" target="_blank" className="hiddenItem">
            HiddenClick
          </a>
          <a href={`${process.env.REACT_APP_BASE_URL}/file/reportById/${installationDetail?.id}`}>
            <button type="button" className="btn app-btn-default dark-color">
              Download Report
            </button>
          </a>
        </div>
        <div className="card-body">
          <Row className="top-row">
            <div className="col-md-2">
              <dd className="display-title mb-1">Item/Asset #</dd>
              <dt className="display-value">{installationDetail.itemNumber}</dt>
            </div>
            <div className="col-md-2">
              <dd className="display-title mb-1">Machine Name</dd>
              <dt className="display-value">
                {!installationDetail.machineRequestId ? installationDetail.item : installationDetail?.machine_request?.model}
              </dt>
            </div>
            <div className="col-md-2">
              <dd className="display-title mb-1">Installation Charges</dd>
              <dt className="display-value">₹{installationDetail.charges}</dt>
            </div>
            <div className="col-md-2">
              <dd className="display-title mb-1">Section</dd>
              <dt className="display-value">{installationDetail.section}</dt>
            </div>
            <div className="col-md-2">
              <dd className="display-title mb-1">Status</dd>
              <dt className="display-value">{installationDetail.status}</dt>
            </div>
            <div className="col-md-2">
              <dd className="display-title mb-1">Description</dd>
              <dt className="display-value">{installationDetail.description}</dt>
            </div>
            <div className="col-md-2">
              <dd className="display-title mb-1">Installation Date</dd>
              <dt className="display-value">{formatDate(installationDetail.installationDate)}</dt>
            </div>
            <div className="col-md-2">
              <dd className="display-title mb-1">Approved By</dd>
              <dt className="display-value">{installationDetail.purchase_order?.initiatedBy}</dt>
            </div>
            <div className="col-md-2">
              <dd className="display-title mb-1">Technician Name</dd>
              <dt className="display-value">{installationDetail.technitionName}</dt>
            </div>
            <div className="col-md-2">
              <dd className="display-title mb-1">Technician Contact</dd>
              <dt className="display-value">{installationDetail.technitionContactNumber}</dt>
            </div>
            <div className="col-md-2">
              <dd className="display-title mb-1">Location</dd>
              <dt className="display-value">{installationDetail.location}</dt>
            </div>
            <div className="col-md-2">
              <dd className="display-title mb-1">Factory</dd>
              <dt className="display-value">{installationDetail?.Branch?.name}</dt>
            </div>
            {!resellScrapInfo ? (
              <div className="col-md-2 px-2 mb-2">
                <button
                  disabled={installationDetail?.status === 'SCRAP-RESELL'}
                  onClick={handleShowTransferModal}
                  type="button"
                  className="btn app-btn-default dark-color"
                >
                  Transfer
                </button>
              </div>
            ) : (
              ''
            )}
          </Row>
          {installationDetail.file_1 ||
          installationDetail.file_2 ||
          installationDetail.file_3 ||
          installationDetail.file_4 ||
          installationDetail.file_5 ? (
            <Row>
              <Col xs={4}>
                <h6>Downloads</h6>
                <ul className="list-group">
                  {installationDetail?.userManual !== null ? (
                    <li className="list-group-item">
                      <Row>
                        <Col xs={8} className="file-name">
                          {installationDetail?.userManual}
                        </Col>
                        <Col xs={4} className="text-end actions">
                          <a href={`${process.env.REACT_APP_BASE_URL}/file/download?filePath=${installationDetail?.userManual}`}>
                            <DownloadIcon />
                          </a>
                          <DeleteIcon
                            onClick={(e) => handleShowDocumentModal(e, 'userManual')}
                            style={{ color: 'rgb(220, 53, 69)', cursor: 'pointer' }}
                          />
                        </Col>
                      </Row>
                    </li>
                  ) : (
                    ''
                  )}
                  {installationDetail?.file_1 !== null ? (
                    <li className="list-group-item">
                      <Row>
                        <Col xs={8} className="file-name">
                          {installationDetail?.file_1}
                        </Col>
                        <Col xs={4} className="text-end actions">
                          <a href={`${process.env.REACT_APP_BASE_URL}/file/download?filePath=${installationDetail?.file_1}`}>
                            <DownloadIcon />
                          </a>
                          <DeleteIcon
                            onClick={(e) => handleShowDocumentModal(e, 'file_1')}
                            style={{ color: 'rgb(220, 53, 69)', cursor: 'pointer' }}
                          />
                        </Col>
                      </Row>
                    </li>
                  ) : (
                    ''
                  )}
                  {installationDetail?.file_2 !== null ? (
                    <li className="list-group-item">
                      <Row>
                        <Col xs={8} className="file-name">
                          {installationDetail?.file_2}
                        </Col>
                        <Col xs={4} className="text-end actions">
                          <a href={`${process.env.REACT_APP_BASE_URL}/file/download?filePath=${installationDetail?.file_2}`}>
                            <DownloadIcon />
                          </a>
                          <DeleteIcon
                            onClick={(e) => handleShowDocumentModal(e, 'file_2')}
                            style={{ color: 'rgb(220, 53, 69)', cursor: 'pointer' }}
                          />
                        </Col>
                      </Row>
                    </li>
                  ) : (
                    ''
                  )}
                  {installationDetail?.file_3 !== null ? (
                    <li className="list-group-item">
                      <Row>
                        <Col xs={8} className="file-name">
                          {installationDetail?.file_3}
                        </Col>
                        <Col xs={4} className="text-end actions">
                          <a href={`${process.env.REACT_APP_BASE_URL}/file/download?filePath=${installationDetail?.file_3}`}>
                            <DownloadIcon />
                          </a>
                          <DeleteIcon
                            onClick={(e) => handleShowDocumentModal(e, 'file_3')}
                            style={{ color: 'rgb(220, 53, 69)', cursor: 'pointer' }}
                          />
                        </Col>
                      </Row>
                    </li>
                  ) : (
                    ''
                  )}
                  {installationDetail?.file_4 !== null ? (
                    <li className="list-group-item">
                      <Row>
                        <Col xs={8} className="file-name">
                          {installationDetail?.file_4}
                        </Col>
                        <Col xs={4} className="text-end actions">
                          <a href={`${process.env.REACT_APP_BASE_URL}/file/download?filePath=${installationDetail?.file_4}`}>
                            <DownloadIcon />
                          </a>
                          <DeleteIcon
                            onClick={(e) => handleShowDocumentModal(e, 'file_4')}
                            style={{ color: 'rgb(220, 53, 69)', cursor: 'pointer' }}
                          />
                        </Col>
                      </Row>
                    </li>
                  ) : (
                    ''
                  )}
                  {installationDetail?.file_5 !== null ? (
                    <li className="list-group-item">
                      <Row>
                        <Col xs={8} className="file-name">
                          {installationDetail?.file_5}
                        </Col>
                        <Col xs={4} className="text-end actions">
                          <a href={`${process.env.REACT_APP_BASE_URL}/file/download?filePath=${installationDetail?.file_5}`}>
                            <DownloadIcon />
                          </a>
                          <DeleteIcon
                            onClick={(e) => handleShowDocumentModal(e, 'file_5')}
                            style={{ color: 'rgb(220, 53, 69)', cursor: 'pointer' }}
                          />
                        </Col>
                      </Row>
                    </li>
                  ) : (
                    ''
                  )}
                </ul>
              </Col>
            </Row>
          ) : (
            ''
          )}
        </div>
      </div>
      <div>
        {activeTabKey && (
          <Tabs defaultActiveKey={activeTabKey} id="uncontrolled-tab-example" className="mb-3">
            <Tab eventKey="request" title="Requests">
              {installationDetail.requestId ? (
                <div className="card">
                  <div className="card-body">
                    <Row className="top-row">
                      <div className="col-md-2">
                        <dd className="display-title mb-1">Machine Name</dd>
                        <dt className="display-value">{installationDetail?.machine_request?.model}</dt>
                      </div>
                      <div className="col-md-2">
                        <dd className="display-title mb-1">Machine Name</dd>
                        <dt className="display-value">{installationDetail?.machine_request?.section}</dt>
                      </div>
                      <div className="col-md-2">
                        <dd className="display-title mb-1">Requested Date</dd>
                        <dt className="display-value">{formatDate(installationDetail?.machine_request?.requestedDate)}</dt>
                      </div>
                      <div className="col-md-2">
                        <dd className="display-title mb-1">Status</dd>
                        <dt className="display-value">{installationDetail?.machine_request?.status}</dt>
                      </div>
                      <div className="col-md-2">
                        <dd className="display-title mb-1">Requested By</dd>
                        <dt className="display-value">{installationDetail?.machine_request?.requestedBy}</dt>
                      </div>
                      <div className="col-md-2">
                        <dd className="display-title mb-1">Initiated By</dd>
                        <dt className="display-value">{installationDetail?.machine_request?.initiatedBy}</dt>
                      </div>
                      <div className="col-md-2">
                        <dd className="display-title mb-1">Reason</dd>
                        <dt className="display-value">{installationDetail?.machine_request?.reason}</dt>
                      </div>
                    </Row>
                    {installationDetail.machine_request.file1 || installationDetail.machine_request.file2 ? (
                      <Row>
                        <Col xs={4}>
                          <h6>Downloads</h6>
                          <ul className="list-group">
                            {installationDetail?.machine_request?.file1 !== null ? (
                              <li className="list-group-item">
                                <Row>
                                  <Col xs={8} className="file-name">
                                    {installationDetail?.machine_request?.file1}
                                  </Col>
                                  <Col xs={4} className="text-end actions">
                                    <a
                                      href={`${process.env.REACT_APP_BASE_URL}/file/download?filePath=${installationDetail?.machine_request?.file1}`}
                                    >
                                      <DownloadIcon />
                                    </a>
                                  </Col>
                                </Row>
                              </li>
                            ) : (
                              ''
                            )}
                            {installationDetail?.machine_request?.file2 !== null ? (
                              <li className="list-group-item">
                                <Row>
                                  <Col xs={8} className="file-name">
                                    {installationDetail?.machine_request?.file2}
                                  </Col>
                                  <Col xs={4} className="text-end actions">
                                    <a
                                      href={`${process.env.REACT_APP_BASE_URL}/file/download?filePath=${installationDetail?.machine_request?.file2}`}
                                    >
                                      <DownloadIcon />
                                    </a>
                                  </Col>
                                </Row>
                              </li>
                            ) : (
                              ''
                            )}
                          </ul>
                        </Col>
                      </Row>
                    ) : (
                      ''
                    )}
                  </div>
                </div>
              ) : (
                <button type="button" className="btn app-btn-default dark-color" onClick={handleShow}>
                  Create Request
                </button>
              )}
            </Tab>
            <Tab eventKey="po" title="Purchase Order">
              {installationDetail?.requestId && !installationDetail?.purchase_order ? (
                <button type="button" className="btn app-btn-default dark-color" onClick={handleShowModal}>
                  Add PO
                </button>
              ) : (
                ''
              )}
              {installationDetail?.purchase_order ? (
                <div className="card">
                  <div className="card-body">
                    <Row className="top-row">
                      <div className="col-md-2">
                        <dd className="display-title mb-1">PO Number</dd>
                        <dt className="display-value">{installationDetail?.purchase_order?.poNumber}</dt>
                      </div>
                      <div className="col-md-3">
                        <dd className="display-title mb-1">Machine Name</dd>
                        <dt className="display-value">{installationDetail?.purchase_order?.item}</dt>
                      </div>
                      <div className="col-md-2">
                        <dd className="display-title mb-1">Amount</dd>
                        <dt className="display-value">₹{installationDetail?.purchase_order?.amount}</dt>
                      </div>
                      <div className="col-md-2">
                        <dd className="display-title mb-1">Approved By</dd>
                        <dt className="display-value">{installationDetail?.purchase_order?.initiatedBy}</dt>
                      </div>
                      <div className="col-md-2">
                        <dd className="display-title mb-1">Approved Date</dd>
                        <dt className="display-value">{formatDate(installationDetail?.purchase_order?.approvedDate)}</dt>
                      </div>
                    </Row>
                    {installationDetail.purchase_order.file_1 || installationDetail.purchase_order.file_2 ? (
                      <Row>
                        <Col xs={4}>
                          <h6>Downloads</h6>
                          <ul className="list-group">
                            {installationDetail?.purchase_order?.file_1 !== null ? (
                              <li className="list-group-item">
                                <Row>
                                  <Col xs={8} className="file-name">
                                    {installationDetail?.purchase_order?.file_1}
                                  </Col>
                                  <Col xs={4} className="text-end actions">
                                    <a
                                      href={`${process.env.REACT_APP_BASE_URL}/file/download?filePath=${installationDetail?.purchase_order?.file_1}`}
                                    >
                                      <DownloadIcon />
                                    </a>
                                  </Col>
                                </Row>
                              </li>
                            ) : (
                              ''
                            )}
                            {installationDetail?.purchase_order?.file_2 !== null ? (
                              <li className="list-group-item">
                                <Row>
                                  <Col xs={8} className="file-name">
                                    {installationDetail?.purchase_order?.file_2}
                                  </Col>
                                  <Col xs={4} className="text-end actions">
                                    <a
                                      href={`${process.env.REACT_APP_BASE_URL}/file/download?filePath=${installationDetail?.purchase_order?.file_2}`}
                                    >
                                      <DownloadIcon />
                                    </a>
                                  </Col>
                                </Row>
                              </li>
                            ) : (
                              ''
                            )}
                            {installationDetail?.purchase_order?.file_3 !== null ? (
                              <li className="list-group-item">
                                <Row>
                                  <Col xs={8} className="file-name">
                                    {installationDetail?.purchase_order?.file_3}
                                  </Col>
                                  <Col xs={4} className="text-end actions">
                                    <a
                                      href={`${process.env.REACT_APP_BASE_URL}/file/download?filePath=${installationDetail?.purchase_order?.file_3}`}
                                    >
                                      <DownloadIcon />
                                    </a>
                                  </Col>
                                </Row>
                              </li>
                            ) : (
                              ''
                            )}
                          </ul>
                        </Col>
                      </Row>
                    ) : (
                      ''
                    )}
                  </div>
                </div>
              ) : (
                ''
              )}
              {!installationDetail?.purchase_order && !installationDetail?.requestId ? (
                <div className="card">
                  <div className="card-body p-0">
                    <div className="alert alert-warning mb-0" role="alert">
                      <strong>First Need to Create Machine Request</strong>
                    </div>
                  </div>
                </div>
              ) : (
                ''
              )}
            </Tab>
            <Tab eventKey="service-remainder" title="Service Remainders">
              <div className="card top-card">
                <div className="card-body">
                  <div className="row">
                    <div className="form-group col-md-4 col-lg-4">
                      <label htmlFor="exampleInputEmail1">Service Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="exampleInputEmail1"
                        placeholder="Please enter Service Name"
                        value={serviceName}
                        onChange={(e) => {
                          setServiceName(e.target.value);
                        }}
                      />
                    </div>
                    <div className="form-group col-md-8 col-lg-8">
                      <div className="btn-wrapper justify-content-start cmt-3">
                        <button
                          type="button"
                          className="btn app-btn-default"
                          onClick={(e) => {
                            setServiceName('');
                          }}
                        >
                          Reset
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card">
                <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
                  <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
                    Service Remainder | {serviceList?.length}
                  </h4>
                  <button onClick={handleShowServiceRemainderModal} type="button" className="btn app-btn-primary">
                    Create
                  </button>
                </div>
                {serviceList?.length > 0 ? (
                  <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
                    <div className="row">
                      <div className="col">
                        <Table responsive striped>
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>Name</th>
                              <th>Description</th>
                              <th>Type</th>
                              <th>Status</th>
                              <th>Due Date</th>
                              <th>Factory</th>
                              <th>Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            {serviceList?.map((request, index) => {
                              return (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  <td>{request.name}</td>
                                  <td>{request.description}</td>
                                  <td>{request.type}</td>
                                  <td>{request.status}</td>
                                  <td>{formatDate(request.dueDate)}</td>
                                  <td>{request?.Branch?.name}</td>
                                  <td className="actions">
                                    <span onClick={(e) => editServiceRemainderRequest(e, request.id)} className="edit-icon">
                                      <EditIcon />
                                    </span>
                                    &nbsp;&nbsp;
                                    <Link to="/" onClick={(e) => handleShowConfirmModal(e, request.id)}>
                                      <DeleteIcon />
                                    </Link>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </Table>
                        <PaginationInPage
                          currentPage={currentPage}
                          setCurrentPage={setCurrentPage}
                          totalRecords={totalRecords}
                          TABLE_DEFAULT_LIMIT={TABLE_DEFAULT_LIMIT}
                        />
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
                    <h4 className="card-title mb-0" style={{ fontSize: '16px', color: 'red' }}>
                      No Data Available
                    </h4>
                  </div>
                )}
              </div>
            </Tab>
            <Tab eventKey="breakdown" title="Breakdown">
              <div className="card top-card">
                <div className="card-body">
                  <div className="row">
                    {/* <div className="form-group col-md-4 col-lg-4">
                      <label htmlFor="exampleInputEmail1">Machine Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="exampleInputEmail1"
                        placeholder="Please enter Machine Name"
                        value={machineName}
                        onChange={(e) => {
                          setMachineName(e.target.value);
                        }}
                      />
                    </div> */}
                    <div className="form-group col-md-2 col-lg-4">
                      <label htmlFor="exampleInputEmail1">Status</label>
                      <Form.Select
                        value={status}
                        onChange={(e) => {
                          setStatus(e.target.value);
                        }}
                        className="all-select-custom"
                        aria-label="Default select example"
                      >
                        <option value="" disabled hidden>
                          Select Status
                        </option>
                        <option value="PENDING">PENDING</option>
                        <option value="REPAIRED">REPAIRED</option>
                      </Form.Select>
                    </div>
                    <div className="form-group col-md-8 col-lg-8">
                      <div className="btn-wrapper justify-content-start cmt-3">
                        <button type="button" className="btn app-btn-default" onClick={() => setStatus('')}>
                          Reset
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card">
                <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
                  <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
                    Breakdown | {breakdownList?.length}
                  </h4>
                  <button onClick={handleShowBreakdownModal} type="button" className="btn app-btn-primary">
                    Create
                  </button>
                </div>
                {breakdownList?.length > 0 ? (
                  <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
                    <div className="row">
                      <div className="col">
                        <Table responsive striped>
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>Machine Name</th>
                              <th>Section</th>
                              <th>Reason</th>
                              <th>Status</th>
                              <th>Break Date</th>
                              <th>Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            {breakdownList?.map((request, index) => {
                              return (
                                <tr key={request.id}>
                                  <td>{(currentPage - 1) * TABLE_DEFAULT_LIMIT + (index + 1)}</td>
                                  <td>{installationDetail?.item}</td>
                                  <td>{installationDetail?.section}</td>
                                  <td>{request.reason}</td>
                                  <td>{request.status}</td>
                                  <td>{formatDate(request.breakDate)}</td>
                                  <td className="actions">
                                    <a href={`${process.env.REACT_APP_BASE_URL}/file/breakdownReportById/${request?.id}`}>
                                      <DownloadIcon />
                                    </a>
                                    <a href="/" onClick={(e) => editAndViewBreakdownRequest(e, request.id, 'edit')} className="edit-icon">
                                      <EditIcon />
                                    </a>
                                    &nbsp;&nbsp;
                                    <a href="/" onClick={(e) => editAndViewBreakdownRequest(e, request.id, 'view')}>
                                      <ViewIcon style={{ color: 'purple' }} />
                                    </a>
                                    <Link to="/" onClick={(e) => handleBreakdownConfirmModal(e, request.id)}>
                                      <DeleteIcon />
                                    </Link>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </Table>
                        <PaginationInPage
                          currentPage={currentPage}
                          setCurrentPage={setCurrentPage}
                          totalRecords={totalRecords}
                          TABLE_DEFAULT_LIMIT={TABLE_DEFAULT_LIMIT}
                        />
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
                    <h4 className="card-title mb-0" style={{ fontSize: '16px', color: 'red' }}>
                      No Data Available
                    </h4>
                  </div>
                )}
              </div>
            </Tab>
            <Tab eventKey="spares" title="Spares">
              <div className="card top-card">
                <div className="card-body">
                  <div className="row">
                    <div className="form-group col-md-4 col-lg-4">
                      <label htmlFor="exampleInputEmail1">Spare Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="exampleInputEmail1"
                        placeholder="Please enter Spare Name"
                        value={spareName}
                        onChange={(e) => {
                          setSpareName(e.target.value);
                        }}
                      />
                    </div>
                    <div className="form-group col-md-8 col-lg-8">
                      <div className="btn-wrapper justify-content-start cmt-3">
                        <button type="button" className="btn app-btn-default" onClick={() => setSpareName('')}>
                          Reset
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card">
                <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
                  <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
                    Spares | {spareList.length}
                  </h4>
                  <button onClick={handleShowSpareModal} type="button" className="btn app-btn-primary">
                    Create
                  </button>
                </div>
                {spareList?.length > 0 ? (
                  <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
                    <div className="row">
                      <div className="col">
                        <Table responsive striped>
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>Spare Name</th>
                              <th>Quantity</th>
                              <th>Description</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {spareList?.map((request, index) => {
                              return (
                                <tr key={request.id}>
                                  <td>{(currentPage - 1) * TABLE_DEFAULT_LIMIT + (index + 1)}</td>
                                  <td>{request.name}</td>
                                  <td>{request.quantity}</td>
                                  <td>{request.description}</td>
                                  <td className="actions">
                                    <span onClick={(e) => editSpareRequest(e, request.id)} className="edit-icon">
                                      <EditIcon />
                                    </span>
                                    &nbsp;&nbsp;
                                    <Link to="/" onClick={(e) => handleSpareConfirmModal(e, request.id)}>
                                      <DeleteIcon />
                                    </Link>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </Table>
                        <PaginationInPage
                          currentPage={currentPage}
                          setCurrentPage={setCurrentPage}
                          totalRecords={totalRecords}
                          TABLE_DEFAULT_LIMIT={TABLE_DEFAULT_LIMIT}
                        />
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
                    <h4 className="card-title mb-0" style={{ fontSize: '16px', color: 'red' }}>
                      No Data Available
                    </h4>
                  </div>
                )}
              </div>
            </Tab>
            <Tab eventKey="resell-scrap" title="Resell / Scrap">
              {!resellScrapInfo ? (
                <button onClick={handleShowResellScrapModal} className="btn btn-danger" type="button">
                  Resell / Scrap this product
                </button>
              ) : (
                <div className="card">
                  <div className="card-body">
                    <Row className="top-row">
                      <div className="col-md-2">
                        <dd className="display-title mb-1">Type</dd>
                        <dt className="display-value">{resellScrapInfo.type}</dt>
                      </div>
                      <div className="col-md-2">
                        <dd className="display-title mb-1">Resell Date</dd>
                        <dt className="display-value">{formatDate(resellScrapInfo.date)}</dt>
                      </div>
                      <div className="col-md-2">
                        <dd className="display-title mb-1">Approved By</dd>
                        <dt className="display-value">{resellScrapInfo.approvedBy}</dt>
                      </div>
                      <div className="col-md-2">
                        <dd className="display-title mb-1">Supervised By</dd>
                        <dt className="display-value">{resellScrapInfo.supervisedBy}</dt>
                      </div>
                      <div className="col-md-2">
                        <dd className="display-title mb-1">Amount</dd>
                        <dt className="display-value">₹{resellScrapInfo.resellAmount}</dt>
                      </div>
                      <div className="col-md-2">
                        <dd className="display-title mb-1">Reason</dd>
                        <dt className="display-value">{resellScrapInfo.reason}</dt>
                      </div>
                    </Row>
                    <Row className="top-row">
                      <div className="col-md-2">
                        <dd className="display-title mb-1">Buyer</dd>
                        <dt className="display-value">{resellScrapInfo.to_whom}</dt>
                      </div>
                      <div className="col-md-2">
                        <dd className="display-title mb-1">Buyer Contact Person</dd>
                        <dt className="display-value">{resellScrapInfo.buyerContactPerson}</dt>
                      </div>
                      <div className="col-md-2">
                        <dd className="display-title mb-1">Buyer Contact</dd>
                        <dt className="display-value">{resellScrapInfo.buyerContactNumber}</dt>
                      </div>
                      <div className="col-md-2">
                        <dd className="display-title mb-1">Buyer Email</dd>
                        <dt className="display-value">{resellScrapInfo.buyerEmail}</dt>
                      </div>
                      <div className="col-md-2">
                        <dd className="display-title mb-1">Buyer GST</dd>
                        <dt className="display-value">{resellScrapInfo.buyerGST}</dt>
                      </div>
                    </Row>
                    {resellScrapInfo.file_1 || resellScrapInfo.file_2 || resellScrapInfo.file_3 ? (
                      <Col xs={4}>
                        <h6>Downloads</h6>
                        <ul className="list-group">
                          {resellScrapInfo?.file_1 !== null ? (
                            <li className="list-group-item">
                              <Row>
                                <Col xs={8} className="file-name">
                                  {resellScrapInfo?.file_1}
                                </Col>
                                <Col xs={4} className="text-end actions">
                                  <a href={`${process.env.REACT_APP_BASE_URL}/file/download?filePath=${resellScrapInfo?.file_1}`}>
                                    <DownloadIcon />
                                  </a>
                                  <DeleteIcon
                                    onClick={(e) => handleShowResellDocumentModal(e, 'file_1')}
                                    style={{ color: 'rgb(220, 53, 69)', cursor: 'pointer' }}
                                  />
                                </Col>
                              </Row>
                            </li>
                          ) : (
                            ''
                          )}
                          {resellScrapInfo?.file_2 !== null ? (
                            <li className="list-group-item">
                              <Row>
                                <Col xs={8} className="file-name">
                                  {resellScrapInfo?.file_2}
                                </Col>
                                <Col xs={4} className="text-end actions">
                                  <a href={`${process.env.REACT_APP_BASE_URL}/file/download?filePath=${resellScrapInfo?.file_2}`}>
                                    <DownloadIcon />
                                  </a>
                                  <DeleteIcon
                                    onClick={(e) => handleShowResellDocumentModal(e, 'file_2')}
                                    style={{ color: 'rgb(220, 53, 69)', cursor: 'pointer' }}
                                  />
                                </Col>
                              </Row>
                            </li>
                          ) : (
                            ''
                          )}
                          {resellScrapInfo?.file_3 !== null ? (
                            <li className="list-group-item">
                              <Row>
                                <Col xs={8} className="file-name">
                                  {resellScrapInfo?.file_3}
                                </Col>
                                <Col xs={4} className="text-end actions">
                                  <a href={`${process.env.REACT_APP_BASE_URL}/file/download?filePath=${resellScrapInfo?.file_3}`}>
                                    <DownloadIcon />
                                  </a>
                                  <DeleteIcon
                                    onClick={(e) => handleShowDocumentModal(e, 'file_3')}
                                    style={{ color: 'rgb(220, 53, 69)', cursor: 'pointer' }}
                                  />
                                </Col>
                              </Row>
                            </li>
                          ) : (
                            ''
                          )}
                        </ul>
                      </Col>
                    ) : (
                      ''
                    )}
                  </div>
                </div>
              )}
            </Tab>
            <Tab eventKey="log-entries" title="Diesel Log Entries">
              <DieselLogEntry installationId={params.id} />
            </Tab>
          </Tabs>
        )}
      </div>
      <Modal size="lg" show={showServiceRemainderModal} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header>
          <Modal.Title>{serviceForm.id ? 'Edit Service' : 'Add Service'}</Modal.Title>
          <button type="button" className="btn-close" aria-label="Close" onClick={handleCloseServiceRemainderModal}></button>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Service Name" className="mb-3">
                  <Form.Control
                    onChange={handleChange}
                    value={serviceForm.name}
                    className="input"
                    name="name"
                    type="text"
                    placeholder="Service Name"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Description" className="mb-3">
                  <Form.Control
                    onChange={handleChange}
                    value={serviceForm.description}
                    className="input"
                    name="description"
                    type="text"
                    placeholder="Description"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Due Date" className="mb-3">
                  <Form.Control
                    onChange={handleChange}
                    value={serviceForm.dueDate}
                    className="input"
                    name="dueDate"
                    type="date"
                    placeholder="Due Date"
                    required
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row className="mb-4">
              <Col xs={4}>
                <FloatingLabel controlId="floatingSelect" label="Type">
                  <Form.Select
                    value={serviceForm.type}
                    onChange={handleSelect}
                    name="type"
                    aria-label="Floating label select example"
                    required
                  >
                    {/* <option>Select Service Type</option> */}
                    <option value="FREE">Free</option>
                    <option value="PAID">Paid</option>
                  </Form.Select>
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingSelect" label="Status">
                  <Form.Select
                    value={serviceForm.status}
                    onChange={handleSelect}
                    name="status"
                    aria-label="Floating label select example"
                    required
                  >
                    {/* <option>Select Service Status</option> */}
                    <option value="PENDING">Pending</option>
                    <option value="COMPLETED">Completed</option>
                  </Form.Select>
                </FloatingLabel>
              </Col>
            </Row>
            <div className={serviceForm.status === 'COMPLETED' ? 'service-completion-detail' : 'hidden-service-completion-detail'}>
              <Row className="bottom-content mb-4">
                <Col xs={12}>
                  <Alert.Heading>Service Completion Details</Alert.Heading>
                  <hr />
                </Col>
                <Col xs={4}>
                  <FloatingLabel controlId="floatingInput" label="Technician Name" className="mb-3">
                    <Form.Control
                      onChange={handleChange}
                      value={serviceForm.technicianName}
                      className="input"
                      name="technicianName"
                      type="text"
                      placeholder="Technician Name"
                      required
                    />
                  </FloatingLabel>
                </Col>
                <Col xs={4}>
                  <FloatingLabel controlId="floatingInput" label="Technician Contact Number" className="mb-3">
                    <Form.Control
                      onChange={handleChange}
                      value={serviceForm.technicianContactNumber}
                      className="input"
                      name="technicianContactNumber"
                      type="number"
                      placeholder="Technician Contact Number"
                      required
                    />
                  </FloatingLabel>
                </Col>
                <Col xs={4}>
                  <FloatingLabel controlId="floatingInput" label="Serviced Date" className="mb-3">
                    <Form.Control
                      onChange={handleChange}
                      value={serviceForm.servicedDate}
                      className="input"
                      name="servicedDate"
                      type="date"
                      placeholder="Serviced Date"
                      required
                    />
                  </FloatingLabel>
                </Col>
                <Col xs={4}>
                  <FloatingLabel controlId="floatingInput" label="Service Comments" className="mb-3">
                    <Form.Control
                      onChange={handleChange}
                      value={serviceForm.serviceComments}
                      className="input"
                      name="serviceComments"
                      type="text"
                      placeholder="Service Comments"
                    />
                  </FloatingLabel>
                </Col>
                <Col xs={4} className="mb-2">
                  <span>Is AMC</span>
                  <input
                    className="react-switch-checkbox"
                    id={`react-switch-new`}
                    type="checkbox"
                    onChange={handleToggle}
                    checked={serviceForm.isAmc}
                    name="isAmc"
                  />
                  <label className="react-switch-label" htmlFor={`react-switch-new`}>
                    <span className="no">NO</span>
                    <span className={`react-switch-button`} />
                    <span className="yes">YES</span>
                  </label>
                </Col>
                {serviceForm.isAmc === false ? (
                  <Col xs={4}>
                    <FloatingLabel controlId="floatingInput" label="Labour Cost" className="mb-3">
                      <Form.Control
                        onChange={handleChange}
                        value={serviceForm.serviceCost}
                        className="input"
                        name="serviceCost"
                        type="number"
                        placeholder="Labour Cost"
                        required
                      />
                    </FloatingLabel>
                  </Col>
                ) : (
                  ''
                )}
                <Col xs={4}>
                  <FloatingLabel controlId="floatingInput" label="Material Cost" className="mb-3">
                    <Form.Control
                      onChange={handleChange}
                      value={serviceForm.materialCost}
                      className="input"
                      name="materialCost"
                      type="number"
                      placeholder="Material Cost"
                    />
                  </FloatingLabel>
                </Col>
                <Col xs={4}>
                  <FloatingLabel controlId="floatingInput" label="Supervised By" className="mb-3">
                    <Form.Control
                      onChange={handleChange}
                      value={serviceForm.supervisedBy}
                      className="input"
                      name="supervisedBy"
                      type="text"
                      placeholder="Supervised By"
                      required
                    />
                  </FloatingLabel>
                </Col>
              </Row>
              <Row className="bottom-content">
                <Col xs={12}>
                  <Alert.Heading>Documents</Alert.Heading>
                  <hr />
                </Col>
                <Col xs={4}>
                  <Form.Group controlId="formFile" className="mb-3 images-box">
                    <Form.Label>Document 1</Form.Label>
                    <Form.Control onChange={onChangeDocument1} type="file" name="file_1" aria-required="false" />
                    <p className="file-name">{serviceForm?.file_1}</p>
                  </Form.Group>
                </Col>
                <Col xs={4}>
                  <Form.Group controlId="formFile" className="mb-3 images-box">
                    <Form.Label>Document 2</Form.Label>
                    <Form.Control onChange={onChangeDocument2} type="file" name="document2" aria-required="false" />
                    <p className="file-name">{serviceForm?.file_2}</p>
                  </Form.Group>
                </Col>
                <Col xs={4}>
                  <Form.Group controlId="formFile" className="mb-3 images-box">
                    <Form.Label>Document 3</Form.Label>
                    <Form.Control onChange={onChangeDocument3} type="file" name="document3" aria-required="false" />
                    <p className="file-name">{serviceForm?.file_3}</p>
                  </Form.Group>
                </Col>
                <Col xs={4}>
                  <Form.Group controlId="formFile" className="mb-3 images-box">
                    <Form.Label>Document 4</Form.Label>
                    <Form.Control onChange={onChangeDocument4} type="file" name="document4" aria-required="false" />
                    <p className="file-name">{serviceForm?.file_4}</p>
                  </Form.Group>
                </Col>
              </Row>
            </div>
            <Button onClick={handleSubmit} type="submit" className="add-request-btn mt-4 mb-3 justify-content-center">
              {serviceForm.id ? 'Update' : 'Add'}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
      {/* Add/Edit Breakdown Modal */}
      <Modal size="lg" show={showBreakdownModal} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header>
          <Modal.Title>{breakdownForm.id ? 'Edit Breakdown' : 'Add Breakdown'}</Modal.Title>
          <button type="button" className="btn-close" aria-label="Close" onClick={handleCloseBreakdownModal}></button>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Machine Name" className="mb-3">
                  <Form.Control
                    value={installationDetail?.item}
                    className="input"
                    name="model"
                    type="text"
                    placeholder="Machine Name"
                    required
                    readOnly
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingSelect" label="Machine Type" className="mb-3">
                  <Form.Select value={breakdownForm.section} name="section" aria-label="Floating label select example" required disabled>
                    <option value={`${breakdownForm.section}`}>{breakdownForm.section}</option>
                  </Form.Select>
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Break Date" className="mb-3">
                  <Form.Control
                    onChange={handleBreakdownChange}
                    value={breakdownForm.breakDate}
                    className="input"
                    name="breakDate"
                    type="date"
                    placeholder="Break Date"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingSelect" label="Status" className="mb-3">
                  <Form.Select
                    value={breakdownForm.status}
                    onChange={handleBreakdownSelect}
                    name="status"
                    aria-label="Floating label select example"
                    required
                  >
                    <option>Select Status</option>
                    <option value="PENDING">Pending</option>
                    <option value="REPAIRED">Repaired</option>
                  </Form.Select>
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Reason" className="mb-3">
                  <Form.Control
                    value={breakdownForm.reason}
                    onChange={handleBreakdownChange}
                    className="input"
                    name="reason"
                    type="text"
                    placeholder="Reason"
                    required
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row className="bottom-content mb-4">
              <Col xs={12}>
                <Alert.Heading>Breakdown Document</Alert.Heading>
                <hr />
              </Col>
              <Col xs={4}>
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label>Document 1</Form.Label>
                  <Form.Control onChange={onChangeBreakDocument} data-filename="file_1" type="file" name="file_1" aria-required="false" />
                  <p className="file-name">{breakdownForm?.file_1}</p>
                </Form.Group>
              </Col>
              <Col xs={4}>
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label>Document 2</Form.Label>
                  <Form.Control onChange={onChangeBreakDocument} data-filename="file_2" type="file" name="file_2" aria-required="false" />
                  <p className="file-name">{breakdownForm?.file_2}</p>
                </Form.Group>
              </Col>
              <Col xs={4}>
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label>Document 3</Form.Label>
                  <Form.Control onChange={onChangeBreakDocument} data-filename="file_3" type="file" name="file_3" aria-required="false" />
                  <p className="file-name">{breakdownForm?.file_3}</p>
                </Form.Group>
              </Col>
            </Row>
            <div className={breakdownForm.status === 'REPAIRED' ? 'service-completion-detail' : 'hidden-service-completion-detail'}>
              <Row className="bottom-content mb-4">
                <Col xs={12}>
                  <Alert.Heading>Breakdown Repaired Details</Alert.Heading>
                  <hr />
                </Col>
                <Col xs={4}>
                  <FloatingLabel controlId="floatingInput" label="Technician Name" className="mb-3">
                    <Form.Control
                      onChange={handleBreakdownChange}
                      value={breakdownForm.technicianName}
                      className="input"
                      name="technicianName"
                      type="text"
                      placeholder="Technician Name"
                      required
                    />
                  </FloatingLabel>
                </Col>
                <Col xs={4}>
                  <FloatingLabel controlId="floatingInput" label="Technician Number" className="mb-3">
                    <Form.Control
                      onChange={handleBreakdownChange}
                      value={breakdownForm.technicianContactNumber}
                      className="input"
                      name="technicianContactNumber"
                      type="text"
                      placeholder="Technician Number."
                      required
                    />
                  </FloatingLabel>
                </Col>
                <Col xs={4}>
                  <FloatingLabel controlId="floatingInput" label="Serviced Date" className="mb-3">
                    <Form.Control
                      onChange={handleBreakdownChange}
                      value={breakdownForm.servicedDate}
                      className="input"
                      name="servicedDate"
                      type="date"
                      placeholder="Serviced Date"
                      required
                    />
                  </FloatingLabel>
                </Col>
                <Col xs={4}>
                  <FloatingLabel controlId="floatingInput" label="Service Comments" className="mb-3">
                    <Form.Control
                      onChange={handleBreakdownChange}
                      value={breakdownForm.serviceComments}
                      className="input"
                      name="serviceComments"
                      type="text"
                      placeholder="Service Comments"
                    />
                  </FloatingLabel>
                </Col>
                <Col xs={4} className="mb-2">
                  <span>Is AMC</span>
                  <input
                    className="react-switch-checkbox"
                    id={`react-switch-new`}
                    type="checkbox"
                    onChange={handleToggleBreak}
                    checked={breakdownForm.isAmc}
                    name="isAmc"
                  />
                  <label className="react-switch-label" htmlFor={`react-switch-new`}>
                    <span className="no">NO</span>
                    <span className={`react-switch-button`} />
                    <span className="yes">YES</span>
                  </label>
                </Col>
                {breakdownForm.isAmc === false ? (
                  <Col xs={4}>
                    <FloatingLabel controlId="floatingInput" label="Labour Cost" className="mb-3">
                      <Form.Control
                        onChange={handleBreakdownChange}
                        value={breakdownForm.serviceCost}
                        className="input"
                        name="serviceCost"
                        type="number"
                        placeholder="Labour Cost"
                        required
                      />
                    </FloatingLabel>
                  </Col>
                ) : (
                  ''
                )}
                <Col xs={4}>
                  <FloatingLabel controlId="floatingInput" label="Material Cost" className="mb-3">
                    <Form.Control
                      onChange={handleBreakdownChange}
                      value={breakdownForm.materialCost}
                      className="input"
                      name="materialCost"
                      type="number"
                      placeholder="Material Cost"
                    />
                  </FloatingLabel>
                </Col>
                <Col xs={4}>
                  <FloatingLabel controlId="floatingInput" label="Supervised By" className="mb-3">
                    <Form.Control
                      onChange={handleBreakdownChange}
                      value={breakdownForm.supervisedBy}
                      className="input"
                      name="supervisedBy"
                      type="text"
                      placeholder="Supervised By"
                      required
                    />
                  </FloatingLabel>
                </Col>
              </Row>
              <Col xs={12}>
                <Alert.Heading>Spare details</Alert.Heading>
                <hr />
              </Col>
              {inputFields.map((inputField, index) => (
                <>
                  <div key={index} className="asset-info">
                    <Row className="align-items-center" wrap={true}>
                      <Col xs={4}>
                        <FloatingLabel controlId="floatingInput" label="Spare Name" className="mb-3">
                          <Form.Control
                            onChange={(e) => handleInputChange(index, e, 'spareName')}
                            value={inputField.spareName}
                            className="input"
                            name="spareName"
                            type="text"
                            placeholder="Spare Name"
                          />
                        </FloatingLabel>
                      </Col>
                      <Col xs={4}>
                        <FloatingLabel controlId="floatingInput" label="Numbers" className="mb-3">
                          <Form.Control
                            onChange={(e) => handleInputChange(index, e, 'numbers')}
                            value={inputField.numbers}
                            className="input"
                            name="numbers"
                            type="number"
                            placeholder="Numbers"
                          />
                        </FloatingLabel>
                      </Col>
                      <Col xs={4}>
                        <FloatingLabel controlId="floatingInput" label="Price Per Unit" className="mb-3">
                          <Form.Control
                            onChange={(e) => handleInputChange(index, e, 'price')}
                            value={inputField.price}
                            className="input"
                            name="price"
                            type="number"
                            placeholder="Price Per Unit"
                          />
                        </FloatingLabel>
                      </Col>
                      <Col xs={4}>
                        <FloatingLabel controlId="floatingInput" label="Labour Cost" className="mb-3">
                          <Form.Control
                            onChange={(e) => handleInputChange(index, e, 'labourCost')}
                            value={inputField.labourCost}
                            className="input"
                            name="labourCost"
                            type="number"
                            placeholder="Labour Cost"
                          />
                        </FloatingLabel>
                      </Col>
                      <Col xs={4}>
                        <FloatingLabel controlId="floatingInput" label="Total Amount" className="mb-3">
                          <Form.Control
                            onChange={(e) => handleInputChange(index, e, 'totalAmount')}
                            value={inputField.totalAmount}
                            className="input"
                            name="totalAmount"
                            type="number"
                            placeholder="Total Amount"
                            disabled
                          />
                        </FloatingLabel>
                      </Col>
                      {/* <Col xs={4}>
                          <FloatingLabel controlId="floatingInput" label="Description" className="mb-3">
                            <Input
                              type="text"
                              name="description"
                              value={inputField.description}
                              onChange={(e) => handleInputChange(index, e, 'description')}
                              placeholder="Description"
                            />
                          </FloatingLabel>
                        </Col> */}
                      <Col xs={1} className="text-end mb-3">
                        {inputFields.length > 1 && (
                          <MdDelete
                            onClick={() => handleRemoveInput(index)}
                            className="text-danger"
                            style={{ cursor: 'pointer', fontSize: '27px' }}
                          />
                        )}
                      </Col>
                    </Row>
                  </div>
                  <hr />
                </>
              ))}
              <Row className="mb-2">
                <Col xs={4}>
                  <Button type="button" ref={clickSpareBtn} variant="secondary" size="sm" onClick={handleAddInput}>
                    Add Spares
                  </Button>
                </Col>
                <Col xs={8} className="text-end px-3">
                  <h6 className="text-danger">Sub-Total: {subTotal?.toFixed(2)}</h6>
                </Col>
              </Row>
              <Row className="bottom-content">
                <Col xs={12}>
                  <Alert.Heading>Documents</Alert.Heading>
                  <hr />
                </Col>
                <Col xs={4}>
                  <Form.Group controlId="formFile" className="mb-3 images-box">
                    <Form.Label>Document 4</Form.Label>
                    <Form.Control onChange={onChangeBreakDocument} data-filename="file_4" type="file" name="file_4" aria-required="false" />
                    <p className="file-name">{breakdownForm?.file_4}</p>
                  </Form.Group>
                </Col>
                <Col xs={4}>
                  <Form.Group controlId="formFile" className="mb-3 images-box">
                    <Form.Label>Document 5</Form.Label>
                    <Form.Control onChange={onChangeBreakDocument} data-filename="file_5" type="file" name="file_5" aria-required="false" />
                    <p className="file-name">{breakdownForm?.file_5}</p>
                  </Form.Group>
                </Col>
                <Col xs={4}>
                  <Form.Group controlId="formFile" className="mb-3 images-box">
                    <Form.Label>Document 6</Form.Label>
                    <Form.Control onChange={onChangeBreakDocument} data-filename="file_6" type="file" name="file_6" aria-required="false" />
                    <p className="file-name">{breakdownForm?.file_6}</p>
                  </Form.Group>
                </Col>
                <Col xs={4}>
                  <Form.Group controlId="formFile" className="mb-3 images-box">
                    <Form.Label>Document 7</Form.Label>
                    <Form.Control onChange={onChangeBreakDocument} data-filename="file_7" type="file" name="file_7" aria-required="false" />
                    <p className="file-name">{breakdownForm?.file_7}</p>
                  </Form.Group>
                </Col>
                <Col xs={4}>
                  <Form.Group controlId="formFile" className="mb-3 images-box">
                    <Form.Label>Document 8</Form.Label>
                    <Form.Control onChange={onChangeBreakDocument} data-filename="file_8" type="file" name="file_8" aria-required="false" />
                    <p className="file-name">{breakdownForm?.file_8}</p>
                  </Form.Group>
                </Col>
                <Col xs={4}>
                  <Form.Group controlId="formFile" className="mb-3 images-box">
                    <Form.Label>Document 9</Form.Label>
                    <Form.Control onChange={onChangeBreakDocument} data-filename="file_9" type="file" name="file_9" aria-required="false" />
                    <p className="file-name">{breakdownForm?.file_9}</p>
                  </Form.Group>
                </Col>
                <Col xs={4}>
                  <Form.Group controlId="formFile" className="mb-3 images-box">
                    <Form.Label>Document 10</Form.Label>
                    <Form.Control
                      onChange={onChangeBreakDocument}
                      data-filename="file_10"
                      type="file"
                      name="file_10"
                      aria-required="false"
                    />
                    <p className="file-name">{breakdownForm?.file_10}</p>
                  </Form.Group>
                </Col>
              </Row>
            </div>
            <Button onClick={handleSubmitBreakdown} type="submit" className="add-request-btn mt-4 mb-3 justify-content-center">
              {breakdownForm.id ? 'Update' : 'Add'}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
      <Modal size="lg" show={showSpareModal} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header>
          <Modal.Title>{spareForm.id ? 'Edit Spare' : 'Add Spare'}</Modal.Title>
          <button type="button" className="btn-close" aria-label="Close" onClick={handleCloseSpareModal}></button>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Spare Name" className="mb-3">
                  <Form.Control
                    onChange={handleSpareChange}
                    value={spareForm.name}
                    className="input"
                    name="name"
                    type="text"
                    placeholder="Spare Name"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Quantity" className="mb-3">
                  <Form.Control
                    onChange={handleSpareChange}
                    value={spareForm.quantity}
                    className="input"
                    name="quantity"
                    type="text"
                    placeholder="Quantity"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Description" className="mb-3">
                  <Form.Control
                    onChange={handleSpareChange}
                    value={spareForm.description}
                    className="input"
                    name="description"
                    type="text"
                    placeholder="Description"
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row className="bottom-content mb-4">
              <Col xs={4}>
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label>Document 1</Form.Label>
                  <Form.Control onChange={onChangeSpareDocument} data-filename="file1" type="file" name="file1" aria-required="false" />
                  <p className="file-name">{spareForm?.file1}</p>
                </Form.Group>
              </Col>
              <Col xs={4}>
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label>Document 2</Form.Label>
                  <Form.Control onChange={onChangeSpareDocument} data-filename="file2" type="file" name="file2" aria-required="false" />
                  <p className="file-name">{spareForm?.file2}</p>
                </Form.Group>
              </Col>
            </Row>
            <Button onClick={handleSubmitSpare} type="submit" className="add-request-btn mt-4 mb-3 justify-content-center">
              {spareForm.id ? 'Update' : 'Add'}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
      <Modal size="lg" show={showResellScrapModal} backdrop="static" keyboard={false} className="request-modal PQ">
        <Modal.Header>
          <Modal.Title>Resell / Scrap Machine</Modal.Title>
          <button type="button" className="btn-close" aria-label="Close" onClick={handleCloseResellScrapModal}></button>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row className="mb-3">
              <Col xs={4}>
                <FloatingLabel controlId="floatingSelect" label="Type">
                  <Form.Select
                    value={resellScrapForm.type}
                    onChange={handleResellScrapSelect}
                    name="type"
                    aria-label="Floating label select example"
                    required
                  >
                    <option>Select Type</option>
                    <option value="resell">Resell</option>
                    <option value="scrap">Scrap</option>
                  </Form.Select>
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Date" className="mb-3">
                  <Form.Control
                    onChange={handleChangeScrap}
                    value={resellScrapForm.date}
                    className="input"
                    name="date"
                    type="date"
                    placeholder="Date"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Buyer Name" className="mb-3">
                  <Form.Control
                    onChange={handleChangeScrap}
                    value={resellScrapForm.to_whom}
                    className="input"
                    name="to_whom"
                    type="text"
                    placeholder="Buyer Name"
                    required
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Buyer Contact Number" className="mb-3">
                  <Form.Control
                    onChange={handleChangeScrap}
                    value={resellScrapForm.buyerContactNumber}
                    className="input"
                    name="buyerContactNumber"
                    type="text"
                    placeholder="Buyer Contact Number"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Buyer Email" className="mb-3">
                  <Form.Control
                    onChange={handleChangeScrap}
                    value={resellScrapForm.buyerEmail}
                    className="input"
                    name="buyerEmail"
                    type="text"
                    placeholder="Buyer Email"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Buyer Contact Person" className="mb-3">
                  <Form.Control
                    onChange={handleChangeScrap}
                    value={resellScrapForm.buyerContactPerson}
                    className="input"
                    name="buyerContactPerson"
                    type="text"
                    placeholder="Buyer Contact Person"
                    required
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Buyer GST" className="mb-3">
                  <Form.Control
                    onChange={handleChangeScrap}
                    value={resellScrapForm.buyerGST}
                    className="input"
                    name="buyerGST"
                    type="text"
                    placeholder="Buyer GST"
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Resell Amount" className="mb-3">
                  <Form.Control
                    onChange={handleChangeScrap}
                    value={resellScrapForm.resellAmount}
                    className="input"
                    name="resellAmount"
                    type="text"
                    placeholder="Resell Amount"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Reason" className="mb-3">
                  <Form.Control
                    onChange={handleChangeScrap}
                    value={resellScrapForm.reason}
                    className="input"
                    name="reason"
                    type="text"
                    placeholder="Reason"
                    required
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Approved By" className="mb-3">
                  <Form.Control
                    onChange={handleChangeScrap}
                    value={resellScrapForm.approvedBy}
                    className="input"
                    name="approvedBy"
                    type="text"
                    placeholder="Approved By"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Supervised By" className="mb-3">
                  <Form.Control
                    onChange={handleChangeScrap}
                    value={resellScrapForm.supervisedBy}
                    className="input"
                    name="supervisedBy"
                    type="text"
                    placeholder="Supervised By"
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row className="bottom-content mb-4">
              <Col xs={12}>
                <Alert.Heading>Documents</Alert.Heading>
                <hr />
              </Col>
              <Col xs={4}>
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label>Document 1</Form.Label>
                  <Form.Control
                    onChange={onChangeResellScrapDocument}
                    data-filename="file_1"
                    type="file"
                    name="file_1"
                    aria-required="false"
                  />
                  <p className="file-name">{resellScrapForm.file_1}</p>
                </Form.Group>
              </Col>
              <Col xs={4}>
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label>Document 2</Form.Label>
                  <Form.Control
                    onChange={onChangeResellScrapDocument}
                    data-filename="file_2"
                    type="file"
                    name="file_2"
                    aria-required="false"
                  />
                  <p className="file-name">{resellScrapForm.file_2}</p>
                </Form.Group>
              </Col>
              <Col xs={4}>
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label>Document 3</Form.Label>
                  <Form.Control
                    onChange={onChangeResellScrapDocument}
                    data-filename="file_3"
                    type="file"
                    name="file_3"
                    aria-required="false"
                  />
                  <p className="file-name">{resellScrapForm.file_3}</p>
                </Form.Group>
              </Col>
            </Row>
            <Button onClick={handleSubmitResellScrap} type="submit" className="add-request-btn mt-4 mb-3 justify-content-center">
              Add
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
      <Modal size="sm" show={showConfirmModel} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header className="bg-danger text-light py-2">
          <Modal.Title>Delete Service</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex justify-content-start">
            <img src={AlertIcon} alt="Alert" />
            <p className="ps-3 mb-0">Are you sure? Action cannot be undone.</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="btn-wrapper">
            <button onClick={handleCloseConfirmModal} className="btn app-btn-default btn-sm">
              Cancel
            </button>
            <button onClick={(e) => handleRemove(e, idToDeleted)} className="btn app-btn-danger btn-sm">
              Delete
            </button>
          </div>
        </Modal.Footer>
      </Modal>
      <Modal size="sm" show={breakdownShowConfirmModel} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header className="bg-danger text-light py-2">
          <Modal.Title>Delete Breakdown</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex justify-content-start">
            <img src={AlertIcon} alt="Alert" />
            <p className="ps-3 mb-0">Are you sure? Action cannot be undone.</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="btn-wrapper">
            <button onClick={handleCloseBreakdownConfirmModal} className="btn app-btn-default btn-sm">
              Cancel
            </button>
            <button onClick={(e) => handleRemoveBreakdown(e, idToDeleted)} className="btn app-btn-danger btn-sm">
              Delete
            </button>
          </div>
        </Modal.Footer>
      </Modal>
      <Modal size="sm" show={spareShowConfirmModel} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header className="bg-danger text-light py-2">
          <Modal.Title>Delete Spare</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex justify-content-start">
            <img src={AlertIcon} alt="Alert" />
            <p className="ps-3 mb-0">Are you sure? Action cannot be undone.</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="btn-wrapper">
            <button onClick={handleCloseSpareConfirmModal} className="btn app-btn-default btn-sm">
              Cancel
            </button>
            <button onClick={(e) => handleRemoveSpare(e, idToDeleted)} className="btn app-btn-danger btn-sm">
              Delete
            </button>
          </div>
        </Modal.Footer>
      </Modal>
      <Modal size="lg" show={show} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header>
          <Modal.Title>Add Machine Request</Modal.Title>
          <button type="button" className="btn-close" aria-label="Close" onClick={handleClose}></button>
        </Modal.Header>
        <Modal.Body>
          <Form autoComplete="off" noValidate validated={validated}>
            <Row>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Machine Name" className="mb-3">
                  <Form.Control
                    className="input"
                    name="model"
                    value={machineForm.model}
                    onChange={handleMachineChange}
                    type="text"
                    placeholder="name@example.com"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingSelect" label="Machine Type">
                  <Form.Select
                    value={machineForm.section}
                    onChange={handleSectionSelect}
                    name="section"
                    aria-label="Floating label select example"
                    required
                  >
                    <option>Machine Type</option>
                    <option value="Phone">Phone</option>
                    <option value="Laptop">Laptop</option>
                    <option value="Accesories">Accesories</option>
                    <option value="Others">Others</option>
                  </Form.Select>
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Requested By" className="mb-3">
                  <Form.Control
                    className="input"
                    name="requestedBy"
                    value={machineForm.requestedBy}
                    onChange={handleMachineChange}
                    type="text"
                    placeholder="name@example.com"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Initiated By" className="mb-3">
                  <Form.Control
                    className="input"
                    name="initiatedBy"
                    value={machineForm.initiatedBy}
                    onChange={handleMachineChange}
                    type="text"
                    placeholder="name@example.com"
                    required
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row className="mb-4">
              <Col xs={4} className="requested-date">
                <FloatingLabel controlId="floatingInput" label="Requested Date" className="mb-3">
                  <Form.Control
                    className="input"
                    name="requestedDate"
                    value={machineForm.requestedDate}
                    onChange={handleMachineChange}
                    type="date"
                    placeholder="name@example.com"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={8}>
                <FloatingLabel controlId="floatingInput" label="Reason" className="mb-3">
                  <Form.Control
                    className="input"
                    name="reason"
                    value={machineForm.reason}
                    onChange={handleMachineChange}
                    type="text"
                    placeholder="name@example.com"
                    required
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row className="bottom-content">
              <Col xs={12}>
                <Alert.Heading>Documents</Alert.Heading>
                <hr />
              </Col>
              <Col xs={6}>
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label>Document 1</Form.Label>
                  <Form.Control onChange={onChangeDocumentOne} type="file" name="file1" aria-required="false" />
                </Form.Group>
              </Col>
              <Col xs={6}>
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label>Document 2</Form.Label>
                  <Form.Control onChange={onChangeDocumentOne} type="file" name="file2" aria-required="false" />
                </Form.Group>
              </Col>
            </Row>
            <Button type="submit" onClick={handleMachineSubmit} className="add-request-btn mt-4 mb-3">
              Add Request
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
      <Modal size="lg" show={showPurchaseModal} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header>
          <Modal.Title>Add Purchase Order</Modal.Title>
          <button type="button" className="btn-close" aria-label="Close" onClick={handleCloseModal}></button>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Purchase Number" className="mb-3">
                  <Form.Control
                    autocomplete="off"
                    onChange={handleChangePurchaseOrder}
                    value={purchaseOrderForm.poNumber}
                    className="input"
                    name="poNumber"
                    type="text"
                    placeholder="Purchase Number"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Machine Name" className="mb-3">
                  <Form.Control
                    autocomplete="off"
                    onChange={handleChangePurchaseOrder}
                    value={purchaseOrderForm.item}
                    className="input"
                    name="item"
                    type="text"
                    placeholder="Machine Name"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingSelect" label="Machine Type">
                  <Form.Select
                    value={purchaseOrderForm.section}
                    onChange={handlePOSectionSelect}
                    name="section"
                    aria-label="Floating label select example"
                    required
                  >
                    <option value="Phone">Phone</option>
                    <option value="Laptop">Laptop</option>
                    <option value="Accesories">Accesories</option>
                    <option value="Others">Others</option>
                  </Form.Select>
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Amount" className="mb-3">
                  <Form.Control
                    autocomplete="off"
                    onChange={handleChangePurchaseOrder}
                    value={purchaseOrderForm.amount}
                    className="input"
                    name="amount"
                    type="text"
                    placeholder="Amount"
                    required
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row className="mb-4">
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Approved Date" className="mb-3">
                  <Form.Control
                    autocomplete="off"
                    className="input"
                    name="approvedDate"
                    value={purchaseOrderForm.approvedDate}
                    onChange={handleChangePurchaseOrder}
                    type="date"
                    placeholder="Approved Date"
                    required
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Approved By" className="mb-3">
                  <Form.Control
                    autocomplete="off"
                    onChange={handleChangePurchaseOrder}
                    value={purchaseOrderForm.initiatedBy}
                    className="input"
                    name="initiatedBy"
                    type="text"
                    placeholder="Name of the Approver"
                    required
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row className="bottom-content">
              <Col xs={12}>
                <Alert.Heading>PO Documents</Alert.Heading>
                <hr />
              </Col>
              <Col xs={4}>
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label>Document 1</Form.Label>
                  <Form.Control required onChange={onChangePurchaseDocumentOne} type="file" name="file_1" aria-required="false" />
                </Form.Group>
              </Col>
              <Col xs={4}>
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label>Document 2</Form.Label>
                  <Form.Control onChange={onChangePurchaseDocumentOne} type="file" name="file_2" aria-required="false" />
                </Form.Group>
              </Col>
              <Col xs={4}>
                <Form.Group controlId="formFile" className="mb-3 images-box">
                  <Form.Label>Document 3</Form.Label>
                  <Form.Control onChange={onChangePurchaseDocumentOne} type="file" name="file3" aria-required="false" />
                </Form.Group>
              </Col>
            </Row>
            <Button onClick={(e) => handleApprove(e)} type="submit" className="add-request-btn mt-4 mb-3 justify-content-center">
              Add
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
      <Modal size="sm" show={documentShowConfirmModel} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header className="bg-danger text-light py-2">
          <Modal.Title>Delete Document</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex justify-content-start">
            <img src={AlertIcon} />
            <p className="ps-3 mb-0">Are you sure? Action cannot be undone.</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="btn-wrapper">
            <button onClick={handleCloseDocumentConfirmModal} className="btn app-btn-default btn-sm">
              Cancel
            </button>
            <button onClick={() => deleteFile(fieldToDeleted)} className="btn app-btn-danger btn-sm">
              Delete
            </button>
          </div>
        </Modal.Footer>
      </Modal>
      <Modal size="sm" show={documentShowResellConfirmModel} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header className="bg-danger text-light py-2">
          <Modal.Title>Delete Document</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex justify-content-start">
            <img src={AlertIcon} />
            <p className="ps-3 mb-0">Are you sure? Action cannot be undone.</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="btn-wrapper">
            <button onClick={handleCloseDocumentResellConfirmModal} className="btn app-btn-default btn-sm">
              Cancel
            </button>
            <button onClick={() => deleteResellFile(fieldToDeleted)} className="btn app-btn-danger btn-sm">
              Delete
            </button>
          </div>
        </Modal.Footer>
      </Modal>
      <Modal size="lg" show={showTransferModal} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header>
          <Modal.Title>Transfer</Modal.Title>
          <button type="button" className="btn-close" aria-label="Close" onClick={handleCloseTransferModal}></button>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Factories" className="mb-3">
                  <Form.Select onChange={handleFactory} name="factoryId">
                    <option value="">Select Factory</option>
                    {factories
                      .filter((item) => item?.id !== parseInt(installationDetail?.factoryId))
                      ?.map((item) => {
                        return (
                          <option key={item?.id} value={item?.id}>
                            {item?.name}
                          </option>
                        );
                      })}
                  </Form.Select>
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Approved by" className="mb-3">
                  <Form.Control
                    onChange={handleTransferChange}
                    autocomplete="off"
                    value={transferValue.approvedBy}
                    className="input"
                    name="approvedBy"
                    type="text"
                    placeholder="Approved by"
                  />
                </FloatingLabel>
              </Col>
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Comment" className="mb-3">
                  <Form.Control
                    onChange={handleTransferChange}
                    autocomplete="off"
                    value={transferValue.reason}
                    className="input"
                    name="reason"
                    type="text"
                    placeholder="Comment"
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row className="mb-4">
              <Col xs={4}>
                <FloatingLabel controlId="floatingInput" label="Supervised By" className="mb-3">
                  <Form.Control
                    onChange={handleTransferChange}
                    autocomplete="off"
                    className="input"
                    name="supervisedBy"
                    value={transferValue.supervisedBy}
                    type="text"
                    placeholder="Supervised By"
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Button onClick={handleTransferSubmit} type="submit" className="add-request-btn mt-4 mb-3 justify-content-center">
              Transfer
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
      <Modal size="xl" show={viewDetail} backdrop="static" keyboard={false} className="request-modal">
        <Modal.Header>
          <Modal.Title>Breakdown Details</Modal.Title>
          <button type="button" className="btn-close" aria-label="Close" onClick={handleClose}></button>
        </Modal.Header>
        <Modal.Body>
          <BreakdownDetail data={breakdownForm} />
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

export default InstallationDetails;
